import { AApi } from './AApi';
import type { ApiResult } from '../types/api.types';
import type { ContactBody } from '../types/entities.types';
import type { FavoritesBody, FavoriteType } from '../types/favorites.types';

/** The favorites of the logged-in user: `/favorites`. */
export class FavoritesApi extends AApi {
    /** The page shows all of them, it has no paginator. */
    private readonly MaxPerPage = 500;

    /** Contacts have no id. */
    public getContactKey(contact: Pick<ContactBody, 'organization_id' | 'person_id' | 'position_id'>): string {
        return [contact.organization_id, contact.person_id, contact.position_id].join('-');
    }

    public deleteFavorite(type: FavoriteType, key: string): Promise<ApiResult<undefined>> {
        return this.Client.delete(this.favorite(type, key));
    }

    public listFavorites(): Promise<ApiResult<FavoritesBody>> {
        return this.Client.get(`${this.VersionPath}/favorites${this.toQuery({ per_page: this.MaxPerPage })}`);
    }

    public setFavorite(type: FavoriteType, key: string): Promise<ApiResult<undefined>> {
        return this.Client.put(this.favorite(type, key), {});
    }

    private favorite(type: FavoriteType, key: string): string {
        return `${this.VersionPath}/favorites/${type}/${key}`;
    }
}
